"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CaretRight = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const DEFAULT_SIZE = 24;
const CaretRight = _ref => {
  let {
    size = DEFAULT_SIZE,
    color = "#212121",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    size: size,
    color: color
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M9 17.898c0 1.074 1.265 1.648 2.073.94l6.31-5.521a1.75 1.75 0 0 0 0-2.634l-6.31-5.522C10.265 4.454 9 5.028 9 6.101v11.797Z"
  }));
};
exports.CaretRight = CaretRight;
CaretRight.displayName = "CaretRight";